// file: src/pages/landing/components/ProjectGrid.jsx
import React from 'react';
import { FolderPlus } from 'lucide-react';
import ProjectCard from './ProjectCard';
import styles from './ProjectGrid.module.css';

/**
 * ProjectGrid component displays a grid of project cards with an "Add Project" card
 * @param {Array} projects - Array of project objects
 * @param {Function} onProjectClick - Callback when a project is clicked
 * @param {Function} onProjectDelete - Callback when a project is deleted
 * @param {Function} onAddProject - Callback when "Add Project" card is clicked
 */
function ProjectGrid({ projects, onProjectClick, onProjectDelete, onAddProject }) {
  // Sort projects by last modified date (newest first)
  const sortedProjects = [...projects].sort((a, b) => {
    const aDate = new Date(a.updated_at || a.modified_at || a.created_at || 0);
    const bDate = new Date(b.updated_at || b.modified_at || b.created_at || 0);
    return bDate - aDate;
  });

  return (
    <div className={styles.projectGrid}>
      {/* Add project card - always first */}
      <div
        className={styles.addProjectCard}
        onClick={onAddProject}
      >
        <div className={styles.addProjectContent}>
          <div className={styles.addProjectIcon}>
            <FolderPlus className="h-4 w-4" />
          </div>
          <p className={styles.addProjectText}>
            New Project
          </p>
        </div>
      </div>

      {/* Project cards */}
      {sortedProjects.map((project) => (
        <ProjectCard
          key={project.id}
          project={project}
          onClick={() => onProjectClick(project)}
          onDelete={(event) => onProjectDelete(project, event)}
        />
      ))}
    </div>
  );
}

export default ProjectGrid;
